<template>
    <div class="main-wrapper">
        <img src="@/assets/icon/pagetitle.gif" alt="."/>
        <div style="color: #004F9A;font-size: 24px;font-weight: bold;">{{$t("usrinquire.title")}}</div>
        <div align="left">
            {{$t("usrinquire.usrinquiry_show_text")}}
        </div>
        <div align="left" class="form-list">
            <div>
                <div class="label-content" >{{$t("usrinquire.inquiry_type")}}</div>
                <div style="display: flex; flex-direction: column;">
                    <label v-for="(value,index) in model.inquireType" :key="index">
                        {{value}}
                    </label>
                </div>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">{{$t("usrinquire.comNm")}}</div>
                <label>{{model.comNm}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">会員ID</div>
                <label>{{model.comId}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">{{$t("usrinquire.usrNm")}}</div>
                <label>{{model.usrNm}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">電話番号</div>
                <label>{{model.tel}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">メールアドレス</div>
                <label>{{model.mlAdr}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">{{$t("common.attfile")}}</div>
                <label>{{model.fileName}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">{{$t("usrinquire.trainNm")}}</div>
                <label>{{model.trainName}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
            <div>
                <div class="label-content">{{$t("usrinquire.consult_content")}}</div>
                <label>{{model.inquireContent}}</label>
            </div>
            <hr style="height:1px;border:none;border-top:1px solid black;" />
        </div>
        
        <div style="display: flex;gap:8px;" class="button-group">
            <BButton style="flex: 1" @click="back()">{{$t("usrinquire.back")}}</BButton>
            <BButton style="flex: 1" @click="send()">{{$t("usrinquire.send")}}</BButton>
        </div>
    </div>
</template>
<script>
import { inject, onBeforeMount,ref } from 'vue'
import { useRouter, useRoute } from 'vue-router' 
import { useI18n } from 'vue-i18n'
export default {
    name: 'usrinquire_show',
    setup(){
        gtag('event', 'viewInquiryCheck', {
          'event_name': 'view'
        })
        const router = useRouter() 
        const route = useRoute() 
        const service = inject('service')
        const { t } = useI18n()
        const model = ref({}) 
        onBeforeMount(()=>{
            if(null != route.params.model && undefined != route.params.model) {
                let params = JSON.parse(route.params.model)
                model.value.comId = params.comId
                model.value.comNm = params.comNm
                model.value.usrNm = params.usrNm
                model.value.tel = params.tel
                model.value.mlAdr = params.mlAdr
                model.value.trainName = params.trainName
                model.value.inquireType = params.inquireType
                model.value.inquireContent = params.inquireContent
                model.value.fileName = params.fileName
                sort()
            } else {
                router.push({path:'/usrinquire_new'})
            }
        })
        function back() {
            router.push({ name: 'usrinquirenew', params: { model: JSON.stringify(model.value) }});
        }
        function send() {
            service.usrinquire.send().then(res => {
                router.push({ path: '/usrinquire_confirm'})
            })
        }
        function sort(){
            if(model.value.inquireType && model.value.inquireType.length > 0){
                var temp = []
                model.value.inquireType.forEach(element => {
                    if('ログインについて' == element){
                        temp.push(1)
                    }else if('動作環境について' == element){
                        temp.push(2)
                    }else if('eラーニングについて' == element){
                        temp.push(3)
                    }else if('Webセミナーについて' == element){
                        temp.push(4)
                    }else if('操作方法について（画面の見方）' == element){
                        temp.push(5)
                    }else if('要望' == element){
                        temp.push(6)
                    }else if('その他' == element){
                        temp.push(7)
                    }
                })
                temp.sort()
                model.value.inquireType = []
                temp.forEach(element => {
                    if(1 == element){
                        model.value.inquireType.push(t("usrinquire.about_login"))
                    }else if( 2 == element){
                        model.value.inquireType.push(t("usrinquire.about_action_environment"))
                    }else if( 3 == element){
                        model.value.inquireType.push(t("usrinquire.about_elearning"))
                    }else if( 4 == element){
                        model.value.inquireType.push(t("usrinquire.about_web"))
                    }else if( 5 == element){
                        model.value.inquireType.push(t("usrinquire.about_action_environment_view"))
                    }else if( 6 == element){
                        model.value.inquireType.push(t("usrinquire.about_demand"))
                    }else if( 7 == element){
                        model.value.inquireType.push(t("usrinquire.about_other"))
                    }
                })
            }
        }

        return{
            back,
            send,
            model
        }
    }
}
</script>
<style scoped lang="scss">
    .main-wrapper{
        margin: 0px 16px;
        .form-list{
        label{
            font-weight: 600;
            font-size: 13px;
            line-height: 18px;
            color: #30353B;
            margin-bottom: 4px;
        }
        .label-content{
            font-weight: bold;
            margin-bottom: 8px;
        }
        .form-control{
            padding: 7px 8px;
            background: #FFFFFF;
            border: 1px solid #A8B0BB;
            border-radius: 3px;
            font-weight: 300;
            font-size: 16px;
            line-height: 21px;
            color: #30353B;
            &:focus{
                box-shadow: none;
                border-color: #2394F7;
            }
        }
        .feedback{
            margin-top: 4px;
            font-weight: 300;
            font-size: 12px;
            line-height: 16px;
            color: #EE4967;
        }
    }
    .button-group{
        button{
            margin-top:24px;
            width:100%;
            background: #2394F7;
            border-radius: 4px;
            font-weight: 600;
            font-size: 13px;
            line-height: 18px;
            color: #FFFFFF;
            height: 40px;
            padding: 8px 16px;
            border: none;
        }
    }
}
</style>